<div class="digital-upsell" [ngStyle]="cardStyle">
  @if (settings.selectingMethod.type === 'checkbox') {
    <span class="digital-upsell__checkbox" (click)="toggleSelected()">
      <span class="digital-upsell__checkbox-box" [style.background-color]="selectorColor">
        @if (isSelected) {
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" aria-hidden="true">
            <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        }
      </span>
    </span>
  }

  @if (settings.productImageBase64) {
    <img class="digital-upsell__image" [ngStyle]="imageStyle" [src]="settings.productImageBase64" alt="" />
  }

  <div class="digital-upsell__info">
    <div class="digital-upsell__title-row">
      <span class="digital-upsell__title" [style.color]="settings.appearance.card.textColor">{{ settings.title }}</span>
      @if (settings.tooltip.enabled && settings.tooltip.content) {
        <span class="digital-upsell__info-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
          </svg>
        </span>
      }
      @if (showTimerBadge) {
        <span class="timer-badge" [ngStyle]="timerStyle">
          @if (timerIconUrl) {
            <img class="timer-icon-badge" [src]="timerIconUrl" alt="" />
          }
          <span [innerHTML]="timerMessageHtml"></span>
        </span>
      }
    </div>
    @if (settings.description) {
      <div
        class="digital-upsell__description"
        [style.color]="settings.appearance.card.textColor"
        [innerHTML]="settings.description"></div>
    }
    @if (showTimerStrip) {
      <div class="timer-strip" [ngStyle]="timerStyle" [style.justify-content]="timerAlign">
        @if (timerIconUrl) {
          <img class="timer-icon-strip" [src]="timerIconUrl" alt="" />
        }
        <span [innerHTML]="timerMessageHtml"></span>
      </div>
    }
  </div>

  <div class="digital-upsell__right">
    <span class="digital-upsell__price" [style.color]="settings.appearance.card.textColor">{{ formattedPrice }}</span>
    @if (settings.selectingMethod.type === 'toggle') {
      <span class="digital-upsell__toggle" [style.background-color]="selectorColor" (click)="toggleSelected()">
        <span class="digital-upsell__toggle-knob" [style.left.px]="isSelected ? 22 : 2"></span>
      </span>
    }
  </div>
</div>
